import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../Header/Header';
import ModalEditProfile from '../Profile/ModalEditProfile/ModalEditProfile';
import Modals from '../ModalInfo/Modals';
import CalendarPromoModal from '../CalendarPromo/CalendarPromoModal';
import PopupPreview from '../ModalInfo/PopupPreview';
import Notification from '../Notification/Notification';
import PreviewBodyClass from './PreviewBodyClass';
const Layout = () => {
  const date = new Date();
  const token = JSON.parse(localStorage.getItem('token'));

  return (
    <>
      <PreviewBodyClass />
      <Header />
      <ModalEditProfile />
      <Modals />
      {/* Одноразовий анонс Google Calendar. Кому показати — вирішує бекенд;
          чужі модалки пропускає вперед і сам чекає своєї черги. */}
      <CalendarPromoModal />
      <Notification />
      <PopupPreview />

      <div className={`${token ? 'wrapper' : 'wrapper-sm'}`}>
        <Outlet />
      </div>

      <footer className="footer">
        <span>Copyright &copy; 2019-{date.getFullYear()} <span className="ml-4">New Brain</span></span>
      </footer>
    </ >
  );
};

export default Layout;